var _defs, _path, _path2, _line, _circle, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLoginErrorIcon = function SvgLoginErrorIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 177.58 180",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke-width:0px;}.cls-2{fill:none;stroke:#0089cf;stroke-miterlimit:10;stroke-width:5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m108.71,75.06v-14.94c0-11-8.92-19.92-19.92-19.92h0c-11,0-19.92,8.92-19.92,19.92v14.94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m120.33,139.81h-63.09c-4.58,0-8.3-3.72-8.3-8.3v-39.85c0-4.58,3.72-8.3,8.3-8.3h63.09c4.58,0,8.3,3.72,8.3,8.3v39.85c0,4.58-3.72,8.3-8.3,8.3Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 88.79,
    y1: 116.56,
    x2: 88.79,
    y2: 126.52
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 88.79,
    cy: 106.6,
    r: 9.96
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m145.67,151.63L27.99,32.34c-13.91,15.08-22.44,35.37-22.44,57.66,0,46.58,37.28,84.37,83.24,84.37,21.99,0,42-8.65,56.88-22.75Zm3.92-3.97c13.91-15.08,22.44-35.37,22.44-57.66,0-46.58-37.28-84.38-83.24-84.38-21.99,0-42,8.65-56.88,22.75l117.68,119.29ZM0,90C0,40.29,39.75,0,88.79,0s88.79,40.29,88.79,90-39.75,90-88.79,90S0,139.71,0,90Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLoginErrorIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/login-error-icon.48502705e66354eb41e3093bf1ceee2b.svg";